<!--
 * @Author: LiuMeiYu
 * @Date: 2023-01-04 15:57:19
 * @LastEditors: LiuMeiYu
 * @LastEditTime: 2023-06-07 09:36:23
 * @FilePath: \nivara\src\components\FooterView.vue
 * @Description: *
 * *
 * Copyright (c) 2023 by yihua, All Rights Reserved.
-->
<template>
  <div class="footer-container">
    <div class="footer-content">
      <div class="footer-logo-pages">
        <div class="footer-logo">
          CardSwap
          <div class="concact-box">
            <div>Email: help@cardswap.top</div>
          </div>
        </div>
        <div class="footer-pages">
          <div class="footer-pages-gruop">
            <div class="footer-pages-items">About Us</div>
            <div class="footer-pages-items">Help</div>
            <div class="footer-pages-items">Blog</div>
          </div>
          <div class="footer-pages-gruop">
            <div class="footer-pages-items">News</div>
          </div>
        </div>
      </div>
      <div class="footer-copyright">
        © 2023 CardSwap. All right reserved
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "@vue/runtime-core";

export default defineComponent({
  name: "FooterView",
  setup() {
    return {};
  },
});
</script>

<style lang="less" scoped>
.footer-container {
  position: relative;
  padding: 46px 60px 0 60px;
  background-image: url("../assets/images/footer_bg.png");
  background-repeat: no-repeat;
  background-position: left top;
  background-size: 100% 100%;
  color: #ffffff;
  .footer-content {
    height: 100%;
    color: #ffffff;
    .footer-logo-pages {
      display: flex;
      margin-bottom: 40px;
      .footer-logo {
        flex: 1;
        padding-left: 50px;
        font-size: 40px;
        font-weight: bold;
        text-align: left;
        display: flex;
        .concact-box {
          font-size: 16px;
          display: flex;
          flex-direction: column;
          align-items: center;
          margin-left: 15px;
          margin-top: 15px;
          font-weight: 400;
          a {
            color: #ffffff;
          }
        }
      }
      .footer-pages {
        display: flex;
        flex-direction: column;
        .footer-pages-gruop {
          display: flex;
          .footer-pages-items {
            margin: 20px 50px;
            font-size: 18px;
            a {
              color: #ffffff;
            }
          }
        }
      }
    }
    .footer-copyright {
      height: 110px;
      display: flex;
      justify-content: center;
      align-items: center;
      border-top: 1px solid #ffffff;
    }
  }
}
</style>
